"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onClientEntry = onClientEntry;

/* eslint-disable no-underscore-dangle */
function onClientEntry(_, options) {
  window.__STORYBLOK_ACCESSTOKEN__ = options.accessToken;
  window.__STORYBLOK_PREVIEW_PATH__ = options.previewPath || 'preview';
}